module.exports = __webpack_public_path__ + "static/media/ne.233b097e.svg";